<template>
    <div style="height: 100%;">
        <div id="main" v-show="!rotaAninhada">
            <container-loader
                v-if="isLoading"
            />
            <div class="page">
                <div class="grupo-produto vertical-flow">
                    <div class="listing-header">
                        <div class="title-breadcrumb">
                            <h1 class="title">
                                {{ $t("integracao") }}
                            </h1>
                            <nav class="breadcrumb" aria-label="breadcrumbs">
                                <ul>
                                    <li>
                                        <a class="a-inativo">{{
                                            $t("cadastros")
                                        }}</a>
                                    </li>
                                    <li>
                                        <a class="a-inativo">{{
                                            $t("integracao")
                                        }}</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>

                    <!-- PESQUISA E FILTROS -->
                    <div class="columns is-multiline">
                        <div class="column is-two-quarters">
                            <search-bar
                                :onSearch="debouncedOnSearch"
                                tooltipLabel="msg-campos-pesquisaveis-integracao"
                            />
                        </div>
                        <div class="situacao-select column is-one-quarter">
                            <vss-select
                                ref="categoriaSelect"
                                :options="categoriaSelect"
                                v-model="categoriaSelected"
                                class="no-clear"
                                title="categoria"
                                @input="updateCategoria"
                                :height="40"
                            />
                        </div>

                        <!-- SITUACAO -->
                        <div class="situacao-select column is-one-quarter">
                            <vss-select
                                ref="situacaoSelect"
                                :searchable="false"
                                :options="situacaoSelect"
                                v-model="situacaoSelected"
                                mlLabels
                                title="situacao"
                                @input="updateSituacao"
                                :height="40"
                            />
                        </div>
                    </div>
                    <div class="columns is-flex-wrap">
                        <div class="column is-4" 
                            v-for="(inte, i) in integracaoselect"
                            :key="i">
                            <div class="card">
                                <div class="card-image">
                                    <figure class="image">
                                        <div class="image-box">
                                            <div
                                                class="image-as-background"
                                                :style="{
                                                'background-image': inte.imgurl ? 'url(\'' + inte.imgurl + '\') ' : 'url('+ require('@/assets/img/icons/no-image.svg') + ')',
                                                }">
                                            </div>
                                        </div>
                                    </figure>
                                </div>
                                <div class="card-content">
                                    <p class="subtitle is-6 center block-with-text">
                                        {{ inte.nome }}
                                    </p>
                                    <p class="subtitle is-6 center block-with-text">
                                        {{inte.descricaocategoria ? inte.descricaocategoria : ''}}
                                    </p>
                                </div>
                                <footer class="card-footer">
                                    <p class="card-footer-item">
                                        <b-button
                                            class="botao-acao"
                                            :type="inte.situacaotoken == 0 ? 'is-danger' : 'is-success'"
                                            @click="
                                            $router.push({
                                                name: 'integracao-edit',
                                                params: {
                                                    id: inte.id,
                                                },
                                            })"
                                            :label="$t('saiba-mais')"
                                            :icon-right="inte.situacaotoken == 0 ? 'close' : 'check'"
                                            position="is-left"
                                        />
                                    </p>
                                </footer>
                            </div>
                        </div>
                    </div>
                    <PaginationViewer
                        class="mb-0"
                        :resetPagination="pagination.resetPagination"
                        :totalItems="pagination.totalRows"
                        :perPageOptions="pagination.perPageOptions"
                        :optionStarted="pagination.optionStarted"
                        @change="updatePagination"/>
                </div>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import ApiPartnerService from "@/services/ApiPartnerService";
import ApiCategoriaService from "@/services/ApiCategoriaService";
import ContainerLoader from "@/components/content/loader/ContainerLoader";

export default {
    beforeRouteUpdate(to, from, next) {
        if (
            to.name.includes("integracao") &&
            to.name != "integracao-list"
        ) {
            this.rotaAninhada = true;
            next();
        } else {
            this.rotaAninhada = false;
            this.carregarDados();
            next();
        }
    },
    components: {
        ContainerLoader,
    },
    data() {
        return {
            grupoIntegracao:
                this.$store.state.user.tabelasERPWebServer.includes("GRUPOPRODUTO"),
            allgps: [],
            situacaoSelect: [
                { id: 2, label: "todos" },
                { id: 1, label: "ativos" },
                { id: 0, label: "inativos" },
            ],
            situacaoSelected: { id: 2, label: "todos" },
            service: new ApiPartnerService(this.$http, this.$router),
            apicategoriaservice: new ApiCategoriaService(this.$http, this.$router),
            isLoading: false,
            isEmpty: false,
            queryFilter: "",
            changeThis: {},
            sort: {
                order: "desc",
                column: "DESCRICAO",
            },
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: 10,
                totalRows: 0,
                currentPage: 1,
            },
            debouncedOnSearch: null,
            categoriaSelect: [],
            categoriaSelected: {id: 0, label: "Todos"},
            integracaoselect: [],
            integracaoselected: {},
        };
    },
    created() {
        if (
            this.$route.name.includes("integracao") &&
            this.$route.name != "integracao-list"
        ) {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
        }
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.carregarDados();
    },
    methods: {
        carregarDados(currentPage = 1) {
            this.findAllComboApiCategoria();
            this.findAllApiPartner(currentPage);
        },
        findAllApiPartner(currentPage = 1){
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
                this.isLoading = true;
                this.service
                .findAll(
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacaoSelected.id,
                    this.categoriaSelected.id,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.integracaoselect = value;
                    this.isEmpty = !this.integracaoselect || this.integracaoselect.length <= 0;
                })
                .catch((e) => {
                    this.$root.showMessage("error", "msg-erro-load");
                    console.error("Erro ao carregar", e);
                })
                .finally((_) => {
                    this.pagination.resetPagination = false;
                    this.isLoading = false;
                });
        },
        findAllComboApiCategoria(){
            this.apicategoriaservice
            .findAllCombo()
            .then(this.mapItemsApiCategoria)
            .then((value) => {
                this.categoriaSelect = value;
                this.categoriaSelect.unshift({id: 0, label: "Todos"})
            })
            .catch((e) => {
                this.$root.showMessage("error", "msg-erro-load");
                console.error("Erro ao carregar", e);
            })  
            .finally((_) => {
                if(!this.categoriaSelected && this.categoriaSelect.length > 0){
                    this.categoriaSelected = this.categoriaSelect[0]
                }
            });
        },
        updateSituacao(val) {
            this.situacaoSelected = val 
                ? this.situacaoSelect.filter((v) => v.id == val.id)[0]
                : this.situacaoSelect[0];
            this.carregarDados();
        },
        updateCategoria(val) {
            this.categoriaSelected = val 
                ? this.categoriaSelect.filter((v) => v.id == val.id)[0]
                : this.categoriaSelect[0];
            this.carregarDados();
        },
        sortTable(field, order) {
            this.sort.colum = field;
            this.sort.order = order;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        mapItemsApiCategoria(body) {
            if (body.content) {
                return body.content.map((gp) => {
                    return {
                        id: gp.id,
                        label: gp.descricao
                    };
                });
            }
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            if (body.content) {
                return body.content.map((gp) => {
                    return {
                        id: gp.id,
                        imgurl: gp.imgurl,
                        nome: gp.nome,
                        descricao: gp.descricao,
                        descricaocategoria: gp.apiCategoria && gp.apiCategoria.descricao ? gp.apiCategoria.descricao : '',
                        situacaotoken: gp.situacaotoken == 1 ? 1 : 0,
                    };
                });
            }
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;
    min-height: calc(100% - 50px);
    position: relative;

    .page {
        position: relative;
        padding-left: 0;
        .situacao-select div,
        .produtivo-select div {
            height: 40px;
        }
    }

    .grupo-produto .search-and-filter {
        display: flex;
        justify-content: space-between;
        margin: 10px 0;
    }

    .grupo-produto .search-and-filter {
        .search-bar {
            width: 80%;
        }
        .item-input {
            width: 19%;
        }
    }

    .botao-acao {
        width: 100%;
        height: 100%;
    }
    .grupo-produto .search-and-filter .filter-bar {
        width: 31%;
    }
    .block-with-text {
        height: 20px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
    }
    figure {
        padding: 10px;
        .image-box{
            flex-grow: 0;
            height: 150px;
            width: 100%;
            .image-as-background {
                background-repeat: no-repeat;
                background-position: center;
                background-size: contain;   
                height: 100%;
            }
        }
    }
}
</style>
